// extracted by mini-css-extract-plugin
var _1 = "LoadingIndicatorModal-module__modal--kxQSQ";
export { _1 as "modal" }
